import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

interface EnrollmentListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (enrollment?: string) => void;
  error?: boolean;
  required?: boolean;
  label?: string;
  id?: string;
}

const list = Object.freeze([
  {
    id: 'S',
    value: 'SI',
  },
  {
    id: 'N',
    value: 'NO',
  },
]);

const EnrollmentListComponent = ({
  disabled,
  onChange,
  required,
  value,
  error,
  label = 'Elettore',
  id = 'voter-list',
}: EnrollmentListComponentProps): React.ReactElement => {
  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {required ? `${label} *` : label || undefined}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={required ? `${label} *` : label || undefined}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

EnrollmentListComponent.displayName = 'Enrollment list component';

const EnrollmentList = memo(EnrollmentListComponent);

export default EnrollmentList as typeof EnrollmentListComponent;
